import PropTypes from 'prop-types';
import { useCallback, useEffect, useState } from 'react';

import { SimpleAlert, LoadingSpinner, DefaultTable } from 'twyne-new.ui'

import InputSearchList from '@/components/InputSearchList';
import { APP_PREFIX } from '@/utils/constants';

import { usePageStore } from '../store';

const propTypes = {
  pageId: PropTypes.number,
}

function PagePaths({ pageId }) {
  const [pagePaths, setPagePaths] = useState([])
  const [renderedItems, setRenderedItems] = useState([])
  const { loading, getPagePaths } = usePageStore()
  const [filter, setFilter] = useState('')

  const loadPaths = useCallback(async pageId => {
    const data = await getPagePaths(pageId)
    setPagePaths(data)
    setRenderedItems(data)
  }, [getPagePaths])

  useEffect(() => {
    if (pageId) {
      loadPaths(pageId)
    }
  }, [pageId, loadPaths])

  useEffect(() => {
    const normalizedFilter = filter.trim().toLowerCase()

    if (!normalizedFilter) {
      setRenderedItems(pagePaths)
      return
    }

    const filteredItems = pagePaths.filter(item => {
      const pathId = String(item.path_id ?? '')
      const pathName = String(item.path?.name ?? '').toLowerCase()

      return pathId.includes(normalizedFilter) || pathName.includes(normalizedFilter)
    })

    setRenderedItems(filteredItems)
  }, [filter, pagePaths])

  if (loading) {
    return <SimpleAlert>
      <div className='flex items-center gap-2'>
        Loading paths
        <LoadingSpinner />
      </div>
    </SimpleAlert>
  }

  if (!pagePaths?.length) {
    return <SimpleAlert>This page does not belong to any path.</SimpleAlert>
  }

  const columns = [
    {
      dataField: '',
      text: 'Path',
      formatter: (_, row) => <div onClick={() => window.open(`${APP_PREFIX}/path/paths/${row.path_id}`, '_blank')} className='cursor-pointer hover:underline twy-text-base-accent'>
        #{row.path_id} - {row.path.name}
      </div>,
    },
    {
      dataField: '',
      text: 'Slot',
      formatter: (_, row) => `${(row?.pathContainerSlot?.sort || row?.sort) + 1}`,
      className: 'w-[10vh]',
    },
  ]

  return <>
    <InputSearchList
      className='flex justify-between gap-2 mr-4'
      placeholder="Filter paths"
      value={filter || ''}
      onChange={setFilter} />
    <DefaultTable
      data={renderedItems}
      columns={columns}
      className='max-h-[40vh] overflow-y-auto'
    />
  </>
}

PagePaths.propTypes = propTypes;

export default PagePaths;
